import { render, staticRenderFns } from "./Kurzveranstaltungsliste.vue?vue&type=template&id=4e90a29d"
import script from "./Kurzveranstaltungsliste.vue?vue&type=script&lang=js"
export * from "./Kurzveranstaltungsliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports